import resume from './resume'
import coverletter from './coverLetter'
import linkedin from './linkedin'
import resumeHelp from './resumeHelp'
import coverLetterHelp from './coverLetterHelp'

export default {
  resume,
  coverletter,
  linkedin,
  help: {
    resume: resumeHelp,
    coverletter: coverLetterHelp,
  },
}
